import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "crm:my-2 crm:inline-flex crm:items-center crm:bg-info--bg crm:rounded-md crm:py-1 crm:px-2"
}
const _hoisted_3 = {
  key: 1,
  class: "d-flex align-items-center mt-2 mx-2 justify-content-between w-100"
}
const _hoisted_4 = { class: "d-flex c-pointer" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = {
  key: 0,
  class: "c-grey"
}
const _hoisted_7 = {
  key: 1,
  class: "c-grey ms-2"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 0,
  class: "w-96 ms-4 ps-3"
}
const _hoisted_10 = ["aria-valuenow"]

import { ref, computed, watch, toRefs, inject } from 'vue'
import {formatDateEnToIT} from '../filters/common.filters.js'
import {trash,alert_information_circle,
  delete_cross} from '../svg/svgs.js'
import {usePraticaStore} from "../store/crm.store";
import BaseControlModal from "./BaseControlModal.vue";


export default {
  __name: 'BaseUploadFilesList',
  props: {
  /**
   * Dati inerente il file contenuto
   */
  file: {
    type: [Array, Object],
    default() {
      return {}
    }
  },
  /**
   * Stato del campo
   * Valori Accettati:
   * - readonly | disabled | active | ...
   */
  state: {
    type: String,
    default: null
  },
  /**
   * Se true, viene aggiunta una progress bar
   */
  haveProgress: {
    type: Boolean,
    default: true
  },
  /**
   * progressione dell'upload
   */
  progressSize: {
    type: [String, Number],
    default: 0
  },
  /**
   * url al blob del file
   * da utilizzare per il link di download dei file rigettati
   */
  blob: {
    type: String,
    default: null
  },
  /**
   * indice del file nell'array relativo (filesUploaded oppure filesRejected)
   */
  arrayIndex: {
    type: [String, Number],
    default: null
  },
  mode:{
    type: String,
    default: 'immediateUpload',
    validator(value){
      return ['immediateUpload', 'manualUpload'].includes(value)
    }
  }
},
  emits: [
  'downloadFile-click',
  'removeFile-click'
],
  setup(__props, { emit: __emit }) {

/**
 * @doc Renderizza e gestisce la lista dei file all'interno di un input file
 * @requires BaseInputFile.vue
 */
const props = __props
const emits = __emit

const praticaStore = usePraticaStore();

const modaleAvvisoCancellazione = ref(false)
const fileInfo = ref(props.file)

const dataCaricamentoFormattata = computed(() => {
  return formatDateEnToIT(props.file.data_caricamento)
})

/**
 * emitta l'evento di download con i dati del file da scaricare
 * Il metodo efettivo di download lo recupera dal componente BaseInputFile.vue
 */
const emittaDownloadFileClick = () => {
  emits('downloadFile-click', props.arrayIndex, props.file.documento_id != null ? 'accepted' : 'rejected')
}

/**
 * emitta l'evento di cancellazione con i dati del file da cancellare
 * Il metodo efettivo di cancellazione lo recupera dal componente BaseInputFile.vue
 */
const cancellaFile = () => {
  modaleAvvisoCancellazione.value = false;
  emits('removeFile-click', props.arrayIndex, props.file.documento_id != null ? 'accepted' : 'rejected', props.file.nome_file);
}

/**
 * @param isValid
 * @returns {string}
 */
const setType = (isValid) => { return (isValid) ? 'success' : 'error'}


const {file} = toRefs(props)

watch(file, (newValue) => {
  fileInfo.value = newValue
})

/**
 * @inject {$DesignSystem} recupera la lista dei colori/configurazioni del design system
 */
const $DesignSystem = inject('$DesignSystem')

return (_ctx, _cache) => {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", {
    class: "fade show",
    id: fileInfo.value.name
  }, [
    (_unref(praticaStore).tipoUtenteConnesso === 'notaio' && fileInfo.value.aggiunto_da_utente === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_base_icon, {
            icon: _unref(alert_information_circle),
            sizing: {width: '15px', height: '15px'},
            stroke: _unref($DesignSystem).design_colors.info,
            class: "crm:mr-2"
          }, null, 8 /* PROPS */, ["icon", "stroke"]),
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "crm:text-info" }, "Documento aggiunto autonomamente", -1 /* CACHED */))
        ]))
      : _createCommentVNode("v-if", true),
    (((fileInfo.value.filesystem_name || fileInfo.value.nome_file) || (fileInfo.value.error && fileInfo.value.error !== '')) || props.mode === 'manualUpload')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createCommentVNode(" informazioni relative al file "),
            _createElementVNode("i", {
              class: _normalizeClass(["far me-2 file-list-icon fas fa-file-alt text-danger", [{'c-grey': __props.state === 'disabled'}]]),
              onClick: emittaDownloadFileClick
            }, null, 2 /* CLASS */),
            _createElementVNode("div", {
              class: "d-flex flex-column",
              onClick: emittaDownloadFileClick
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["ellipsis-single-row", {'c-grey text-decoration-line-throught': __props.state === 'disabled'}])
              }, _toDisplayString(fileInfo.value.nome_file), 3 /* TEXT, CLASS */),
              _createElementVNode("span", _hoisted_5, [
                (fileInfo.value.sizeFormatted !== 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(fileInfo.value.sizeFormatted), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (fileInfo.value.data_caricamento)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _cache[3] || (_cache[3] = _createTextVNode(" - ", -1 /* CACHED */)),
                      _createElementVNode("span", { innerHTML: dataCaricamentoFormattata.value }, null, 8 /* PROPS */, _hoisted_8)
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ]),
          _createCommentVNode(" cta per la cancellazione del file "),
          (__props.state !== 'readonly' && !fileInfo.value.is_accettato && _unref(praticaStore).tipoUtenteConnesso !== 'notaio')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-icon d-flex me-4",
                onClick: _cache[0] || (_cache[0] = $event => (modaleAvvisoCancellazione.value = true))
              }, [
                _createVNode(_component_base_icon, {
                  icon: fileInfo.value.documento_id != null && fileInfo.value.documento_id !== undefined && fileInfo.value.documento_id !== '' ? _unref(trash) : _unref(delete_cross),
                  stroke: _unref($DesignSystem).design_colors.primary
                }, null, 8 /* PROPS */, ["icon", "stroke"])
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" slot per aggiunta di actions al file "),
          _renderSlot(_ctx.$slots, "actions")
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" slot per aggiunta di actions al file "),
    _renderSlot(_ctx.$slots, "additionalElement"),
    _createCommentVNode(" file progress bar "),
    (__props.state !== 'readonly' && __props.state !== 'disabled')
      ? (_openBlock(), _createBlock(_Transition, {
          key: 2,
          name: "smooth"
        }, {
          default: _withCtx(() => [
            ((__props.haveProgress && __props.progressSize) || (fileInfo.value.message))
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  ((fileInfo.value.message && __props.haveProgress && __props.progressSize) || (fileInfo.value.message))
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass({'text-success':setType(fileInfo.value.validate) === 'success','text-danger': setType(fileInfo.value.validate) === 'error'})
                      }, [
                        _createElementVNode("small", null, [
                          _createElementVNode("i", null, _toDisplayString(fileInfo.value.message), 1 /* TEXT */)
                        ])
                      ], 2 /* CLASS */))
                    : _createCommentVNode("v-if", true),
                  (__props.haveProgress && __props.progressSize)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["progress-bar progress-bar--file", {'bg-success':setType(fileInfo.value.validate) === 'success','bg-danger':setType(fileInfo.value.validate) === 'error'}]),
                        role: "progressbar",
                        style: _normalizeStyle({ width: __props.progressSize + '%' }),
                        "aria-valuenow": __props.progressSize,
                        "aria-valuemin": "0",
                        "aria-valuemax": "100"
                      }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_10))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    (modaleAvvisoCancellazione.value)
      ? (_openBlock(), _createBlock(BaseControlModal, {
          key: 3,
          message: `il file ${fileInfo.value.nome_file}`,
          "onConfirm:control": cancellaFile,
          "onClose:control": _cache[1] || (_cache[1] = $event => (modaleAvvisoCancellazione.value = false))
        }, null, 8 /* PROPS */, ["message"]))
      : _createCommentVNode("v-if", true)
  ], 8 /* PROPS */, _hoisted_1))
}
}

}